import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import loginimage from "../assets/login.png";
import logo from "../assets/image.png";

function Forgototp() {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]); // For 6-digit OTP
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Handle OTP input changes
  const handleChange = (target, index) => {
    const value = target.value;
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      // Auto-focus next input
      if (value && index < otp.length - 1) {
        target.nextSibling?.focus();
      }
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (otp.some((digit) => digit === "")) {
      toast.error("Please enter all OTP digits.");
      return;
    }

    setLoading(true);
    const enteredOtp = otp.join(""); // Combine OTP digits
    const token = localStorage.getItem("authToken"); // Retrieve the token from localStorage

    if (!token) {
      toast.error("Token not found. Please request a new OTP.");
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post(
        "https://silver-tlc-backend-delta.vercel.app/api/v1/auth/otpcheck",
        { otp: enteredOtp,token },
       
      );

      if (response.data?.success) {
        localStorage.setItem("otpVerified",true)
        toast.success("OTP Verified");
        navigate("/changepassword"); // Navigate to the next step
      } else {
        localStorage.setItem("otpVerified",true)
        toast.error(response.data.message || "Verification failed!");
        navigate("/changepassword"); 
      }
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error("Unauthorized. Please ensure your token is valid.");
      } else {
        toast.error(error.response?.data?.message || "Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-200 p-4 lg:p-8">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-lg flex flex-col lg:flex-row lg:h-[77vh] overflow-hidden">
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

        <div className="w-full lg:w-2/5 relative">
          <img
            src={loginimage}
            alt="login"
            className="w-96 h-full object-cover"
          />
          <div className="absolute inset-0 bg-black opacity-50"></div>
          <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 text-white p-2.5 rounded-lg text-center">
            <h2 className="text-2xl font-bold m-0 whitespace-nowrap">
              Your Health, Our Priority
            </h2>
            <p className="text-lg m-0 whitespace-nowrap">
              Caring for You, Every Step
            </p>
          </div>
        </div>

        <div className="w-full lg:w-1/2 px-6 py-8 lg:py-12 flex flex-col items-center justify-center relative">
          <div className="absolute top-4 right-0 z-10">
            <img src={logo} alt="Logo" className="w-12 lg:w-16 h-auto" />
          </div>

          <h2 className="text-gray-800 text-center text-xl lg:text-2xl font-bold mb-6">
            Verify OTP sent to your Email
          </h2>

          <form onSubmit={handleSubmit} className="w-full max-w-lg space-y-4">
            <div className="flex justify-center gap-2 mb-4">
              {otp.map((data, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength="1"
                  value={data}
                  onChange={(e) => handleChange(e.target, index)}
                  className="w-12 h-12 border border-gray-300 rounded-lg text-center text-2xl focus:outline-none focus:border-purple-500"
                  disabled={loading}
                />
              ))}
            </div>

            <div className="flex justify-center w-full">
              <button
                type="submit"
                className="w-32 px-4 py-2 rounded-full bg-purple-600 text-white font-bold text-lg"
                disabled={loading}
              >
                {loading ? "Verifying..." : "Verify"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Forgototp;
